import { z } from "zod";

import { Template } from "~/tools/template";

const schema = z
	.object({
		text: z
			.string()
			.trim()
			.catch("")
			.transform((text) => Template<null>(text))
			.optional(),
	})
	.catch({});

type Markdown = z.infer<typeof schema>;

const Markdown = { schema };

export { Markdown };
